import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      borderRadius: 16,
      img: {
        borderRadius: 'inherit',
      },
      [theme.fn.largerThan('sm')]: {
        borderRadius: 24,
      },
    },
  }
})
